import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import store from "./store/index";
import PDKPlugin from "@/plugins";
import mixin from "@/plugins/mixin";
import i18n  from "./i18n";
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import { suppressDeprecationWarnings } from "moment";
Vue.use(VuePersianDatetimePicker, {
  name: 'date-picker'
 
});
Vue.use(PDKPlugin);
Vue.use(mixin);
Vue.config.productionTip = false;

// fetch(process.env.BASE_URL + "metaResource.json")
//   .then((response) => response.json())
//   .then((meta) => {
//        Vue.prototype.$metaResource = meta;
//   })
// Vue.use(i18n)


// const messages = {
//   fa: {
//     message: {
//       hello: 'سلام دنیا',
//       suggestedHotels:'هتل های پیشنهادی برای شما',
//     }
//   },
//   en: {
//     message: {
//       hello: 'hello world',
//       suggestedHotels:'Suggested hotels for you',
//     }
//   }
// }

// const i18n = new VueI18n({
//   locale: 'fa', 
//   fallbackLocale:'fa',
//   messages: loadLocaleMessages()
// });


// use beforeEach route guard to set the language
/*
router.beforeEach((to, from, next) => {

  // use the language from the routing param or default language
  let language = to.params.lang;
  if (!language) {
    language = 'fa'
  }
  
  // set the current language for i18n.
  i18n.locale = language
  next()
})*/

fetch(process.env.BASE_URL + "urlConfig.json")
  .then((response) => response.json())
  .then((config) => {
       Vue.prototype.$config = config
       new Vue({
        el:'#app',
        router,
        store,
        i18n,
        render: h => h(App),
      });
  })


